<template>
  <div
    class="crad"
    @click="detailBtn"
    :style="{ border: isAtive ? '2px solid #157cf3' : '2px solid #f5f5f5' }"
  >
    <div class="crad-li">
      <div class="crad-li-l">
        <img
          :src="
            detailInfo.imgUrl
              ? detailInfo.imgUrl
              : require('@/assets/images/home/land.png')
          "
          alt=""
          @click="investmentBtn"
        />
      </div>
      <div class="crad-li-r">
        <div style="display: flex">
          <span class="crad-title-span">{{ detailInfo.name }}</span>
          <div class="pageView">
            <browse :statistical="detailInfo.statistical"></browse>
          </div>
        </div>
        <div class="crad-li-r-li">
          <!-- <div class="crad-li-r-li-r">{{ detailInfo.person }}</div> -->
        </div>
        <div class="crad-li-r-li">
          <!-- <div class="crad-li-r-li-l">联系方式：</div> -->
          <!-- <div class="crad-li-r-li-r">{{ detailInfo.parkNameActual }}</div> -->
        </div>
        <div class="crad-li-r-li">
          <div class="crad-li-r-li-r">
            <!-- {{ detailInfo.leadingIndustry }} -->
            <span v-for="(itm, inx) in detailInfo.labels" :key="inx">
              {{ itm.labelName }}
              <i v-if="inx <= detailInfo.labels.length - 2">、</i>
            </span>
          </div>
        </div>
        <div class="crad-li-r-li">
          <div class="crad-li-r-li-r">
            {{ detailInfo.parkCode != "DZXQ" ? detailInfo.parkLevelName : "" }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Browse from "@/components/currency/browse";
export default {
  name: "park-crad",
  components: { Browse },
  props: {
    detailInfo: {
      type: Object,
      default: () => {
        return {};
      },
    },
    isAtive: {
      type: Boolean,
      default: false,
    },
    nowIndex: {
      type: Number,
      default: null,
    },
  },
  filters: {
    filter_statistical(value) {
      let value1 = 0;
      if (value > 10000) {
        value1 = (value / 10000).toFixed(1) + "万";
      } else {
        value1 = value;
      }
      return value1.toString();
    },
  },
  data() {
    return {
      url: "",
      //isAtive: false, //是否选中
      isAtives_: false,
    };
  },
  watch: {
    isAtive(val) {
      this.isAtives_ = this.isAtive;
    },
  },
  mounted() {
    if (this.isAtive) {
      this.isAtives_ = this.isAtive;
    }
  },
  methods: {
    detailBtn() {
      this.isAtives_ = !this.isAtives_;
      this.$emit("onDetail", this.detailInfo, this.isAtives_, this.nowIndex);
    },
    investmentBtn() {
      this.$emit("onInvestment", this.detailInfo);
    },
    parkLocation() {
      this.$emit("onParkLocation", this.detailInfo.parkCodeActual);
    },
  },
};
</script>
<style  scoped>
.crad {
  border: 1px solid #f5f5f5;
  margin: 0 10px 10px 10px;
  cursor: pointer;
}
.crad-title {
  padding: 0 10px;
  height: 23px;
  line-height: 30px;
  font-size: 15px;
  font-weight: 600;
  color: #0a75da;
  display: flex;
  justify-content: space-between;
}

.crad-li {
  padding: 10px;
  font-size: 14px;
  display: flex;
}
.crad-li-l {
  width: 100px;
  height: 60px;
}
.crad-li-l > img {
  width: 100px;
  height: 66px;
}
.crad-li-r {
  width: calc(100% - 30px);
  padding-left: 10px;
  font-size: 12px;
}

.crad-li-r-li {
  display: flex;
  line-height: 22px;
}
.crad-li-r-li-l {
  width: 65px;
  color: rgb(78, 78, 78);
}
.crad-li-r-li-r {
  width: 200px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  color: rgb(114, 114, 114);
}

.font-red {
  color: red;
  font-weight: 600;
}
.crad-title-span {
  display: inline-block;
  font-size: 16px;
  color: #2c83f6;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  width: 140px;
  height: 20px;
  line-height: 20px;
  margin-bottom: 5px;
}
.crad-border {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 38px;
  border-top: 1px solid rgba(230, 230, 230, 0.5);
}

.pageView {
  margin-left: 10px;
}

.crad-button {
}

.crad-bottom,
button {
  border-radius: 6px;
  border: 1px solid #2c83f6;
  width: 80px;
  height: 24px;
  font-size: 12px;
  margin-right: 10px;
  color: #2c83f6;
  cursor: pointer;
  background: #fff;
}
</style>
